import { MIN_GOAL_AMOUNT, MAX_GOAL_AMOUNT, MAX_POSTS_PER_RECIPIENT_PER_30_DAYS } from '../utils/constants';

export default function CommunityTrustLimits() {
  return (
    <div className="p-6 bg-indigo-50">
      <div className="mb-6 text-center">
        <h3 className="font-bold text-indigo-900 text-lg">Community Trust Limits</h3>
        <p className="text-xs text-indigo-600 uppercase tracking-wider font-semibold mb-3">Ensuring Safety & Sustainability</p>
        <p className="text-[12px] text-indigo-700 leading-relaxed italic max-w-xl mx-auto">These guardrails help with fraud prevention and protect the integrity of the platform, ensuring that every gift remains a safe and joyful experience.</p>
      </div>
      <ul className="space-y-6">
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">📊</span>
          <div className="text-sm leading-relaxed text-indigo-800">
            <strong className="text-indigo-900 block mb-0.5">Foundational Milestones</strong>
            During our community launch, pools are set between <span className="font-bold">${MIN_GOAL_AMOUNT}</span> and <span className="font-bold">${MAX_GOAL_AMOUNT.toLocaleString()}</span> to ensure every request is manageable and secure. We'll raise these limits as we roll out.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">⏳</span>
          <div className="text-sm leading-relaxed text-indigo-800">
            <strong className="text-indigo-900 block mb-0.5">Thoughtful Momentum</strong>
            To ensure every story receives the meaningful attention it deserves, we limit pools to <span className="font-bold">{MAX_POSTS_PER_RECIPIENT_PER_30_DAYS} per recipient every 30 days</span>. This helps keep the community's support focused and impactful.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">💎</span>
          <div className="text-sm leading-relaxed text-indigo-800">
            <strong className="text-indigo-900 block mb-0.5">Earned Capacity</strong>
            Gifted is rooted in reputation. Your gift pool visibility will increase as you participate in the community and earn Vouches and help others.
          </div>
        </li>
      </ul>
    </div>
  );
}
